export default __webpack_public_path__ + "static/media/fish_oil1.bd4d8941.png";